// extracted by mini-css-extract-plugin
export default {"top-panel-wrap":"TopPanel_top-panel-wrap__x8mrL","mobile":"TopPanel_mobile__yAoum","top-panel":"TopPanel_top-panel__mW6+B"};